import { render, staticRenderFns } from "./NewCompany.vue?vue&type=template&id=790137df&"
import script from "./NewCompany.vue?vue&type=script&lang=ts&"
export * from "./NewCompany.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports